<template>
  <v-list dense nav class="px-0">
    <div
      v-if="permissaoRelatoriosChamadas || permissaoRelatoriosConferencias"
      class="px-2"
    >
      <v-list-item
        v-for="(item, i) in itens_relatorios"
        :key="i"
        :href="item.href"
        target="_blank"
        @click="redirect(item.way, $event)"
        :class="isActive(item.way)"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon>
              <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                item.icon
              }}</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{ item.message }}</span>
        </v-tooltip>
        <v-list-item-title class="ml-n4">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { goToSelectedPath } from "@/utils/commomMethods/goToSelectedPath";

import {
  permissoesRelatoriosChamadas,
  permissoesRelatoriosConferencias,
} from "../utils/permissionsRelatoriosPabx";

export default {
  name: "ListNavigationDrawerUser",
  data: () => ({
    itens_relatorios: [],
    permissaoRelatoriosChamadas: false,
    permissaoRelatoriosConferencias: false,
  }),

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage();

    arrayPermissions.forEach((permissionLocalStorage) => {
      if (
        permissoesRelatoriosChamadas.includes(permissionLocalStorage) &&
        !this.permissaoRelatoriosChamadas
      ) {
        this.permissaoRelatoriosChamadas = true;
        this.itens_relatorios.push({
          title: "Chamadas",
          way: "relatorios_pabx_chamadas",
          icon: "mdi-phone-log",
          message: "Relatório de Chamadas",
          href: "/relatorios-pabx/chamadas",
        });
      }
      if (
        permissoesRelatoriosConferencias.includes(permissionLocalStorage) &&
        !this.permissaoRelatoriosConferencias
      ) {
        this.permissaoRelatoriosConferencias = true;
        this.itens_relatorios.push({
          title: "Conferências",
          way: "relatorios_pabx_conferencias",
          icon: "mdi-google-classroom",
          message: "Relatório de Conferências",
          href: "/relatorios-pabx/conferencias",
        });
      }
    });
  },

  methods: {
    ...goToSelectedPath,
    ...obtainUserPermissions,

    isActive(rota) {
      if (rota == this.$route.name) {
        return "indigo lighten-5";
      }
    },
  },
};
</script>
